export const oneTypeDetailEn = {
    zaixianxunjia:"Online inquiry",
    jcrzfw:"Test certification service"
}


// WEBPACK FOOTER //
// ./src/lang/home/oneTypeDetail/oneTypeDetailEn.js